module.exports = function() {
  return new Worker(__webpack_public_path__ + "88e9c2f85bde4d5e2ee4.worker.js");
};